import { render, staticRenderFns } from "./TabProduto.vue?vue&type=template&id=fe024dfe"
import script from "./TabProduto.vue?vue&type=script&lang=js"
export * from "./TabProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports